import Model, { attr } from '@ember-data/model';

export default class UserLoginInfoModel extends Model {
  @attr('string') ssoLoginUrl?: string;
  @attr('string') foreignUserEnvironmentUrl?: string;
  @attr('boolean') loginWithPasskey?: boolean;
  @attr() passkeyOptions?: any;
  @attr('string') passkeyChallenge?: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'unauthenticated/user-login-info': UserLoginInfoModel;
  }
}
